module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "flows-show"
    }
  }, [_c('confirm-modal', {
    attrs: {
      "id": "confirm-destroy-flow-modal",
      "title": _vm.$t('flows.title.flowRemove'),
      "message": _vm.$t('flows.subtitle.flowRemove'),
      "confirm_text": _vm.$t('general.actions.delete'),
      "confirm_class": "btn-danger",
      "visible": _vm.confirming_destroy_flow
    },
    on: {
      "confirm-modal-confirm": _vm.destroyConfirmed
    }
  }), _c('back-link'), _c('div', {
    staticClass: "header-with-action"
  }, [_c('h1', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.flow.name))]), _c('div', {
    staticClass: "extra-config dropdown-export-menu pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        return _vm.openTaskModalForm()
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/images/icons/exportar_icon.svg")
    }
  })])]), (!_vm.current_user.isMonitoringManager()) ? _c('div', {
    staticClass: "dropdown pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary flow-show-actions btn-options dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-cog"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('general.actions.options')))]), _c('span', {
    staticClass: "glyphicon glyphicon-menu-down"
  })]), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.flow.interrupted_contacts) ? _c('li', [_c('a', {
    on: {
      "click": _vm.reengageContacts
    }
  }, [_vm._v(_vm._s(_vm.$t('flows.actions.contactsRollback')) + " ")])]) : _vm._e(), _c('li', [_c('a', {
    on: {
      "click": _vm.confirmDestroy
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.delete')))])]), _c('li', [_c('a', {
    on: {
      "click": _vm.editFlow
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.edit')))])])])]) : _vm._e(), _c('div', {
    staticClass: "flow-status-toggler-wrapper pull-right"
  }, [_c('div', {
    staticClass: "toggler-inline",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleFlowStatus()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.flow.isPublished()
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('flows.label.flowStatus', {
    status: _vm.flow.human_status
  })))])])])]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "flow-details"
  }, [_c('div', {
    staticClass: "flow-actions-count"
  }, [_vm._v(_vm._s(_vm.flow.actions_count) + " " + _vm._s(_vm.$t('general.label.actions')))]), _c('div', {
    staticClass: "flow-days-count"
  }, [_vm._v(" " + _vm._s(_vm.flow.duration_in_days) + " " + _vm._s(_vm.$t('general.label.days')))]), _c('div', {
    staticClass: "flow-weekdays-to-send"
  }, [_vm._v(_vm._s(_vm.flow.human_weekdays_to_send.join(', ')))]), (_vm.flow.emails_per_day) ? _c('div', {
    staticClass: "flow-new-contacts"
  }, [_vm._v(_vm._s(_vm.flow.emails_per_day) + " " + _vm._s(_vm.$t('flows.label.newContactsByDay')) + " ")]) : _c('div', {
    staticClass: "flow-new-contacts"
  }, [_vm._v(_vm._s(_vm.$t('flows.label.dailyActivationLimit')))])]), _c('div', {
    staticClass: "flow-statistics"
  }, [_c('div', {
    staticClass: "statistic-lg"
  }, [_c('div', {
    attrs: {
      "data-toggle": "tooltip",
      "data-original-title": _vm.recipientsByStatusHtml,
      "data-placement": "bottom"
    }
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.contactsCount))]), _c('div', {
    staticClass: "legend"
  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.contacts')))])])]), _c('div', {
    staticClass: "statistic-lg"
  }, [_c('div', {
    attrs: {
      "data-toggle": "tooltip",
      "data-original-title": _vm.detailedConversionStatisticHtml,
      "data-placement": "bottom"
    }
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.recipientsStatisticsConversion))]), _c('div', {
    staticClass: "legend"
  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.conversion')))])])]), _c('div', {
    staticClass: "statistic-lg"
  }, [_c('div', {
    attrs: {
      "data-toggle": "tooltip",
      "data-original-title": _vm.detailedReplyStatisticHtml,
      "data-placement": "bottom"
    }
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.flow.email_statistic.replyPercentage(_vm.flow.recipients_count)))]), _c('div', {
    staticClass: "legend"
  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.reply')))])])])]), _c('ul', {
    staticClass: "tab-list",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#actions-tab",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.$t('flows.title.actions')))])]), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#contacts-tab",
      "role": "tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.trackEventViewContact(_vm.flow)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('flows.title.contacts')))])])]), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "actions-tab",
      "role": "tabpanel"
    }
  }, [_c('action-list', {
    attrs: {
      "actions": _vm.actions
    }
  })], 1), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "contacts-tab",
      "role": "tabpanel"
    }
  }, [(_vm.flow.id) ? _c('contacts', {
    attrs: {
      "flow": _vm.flow
    },
    on: {
      "toggle-task-bar": _vm.toggleTaskBar
    }
  }) : _vm._e()], 1)]), _c('task-modal-form'), _c('modal-flow-form')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15c5e0d3!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flows/show.vue
// module id = 1025
// module chunks = 1